module.exports = __webpack_public_path__ + "static/img/催收欠款模块.5e0a53e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/催收欠款模块.png
// module id = Nne5
// module chunks = 1